async function call(base, id, input, signal) {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}/number`, {
        credentials: 'include',
        signal: signal ?? null,
        method: input ? 'PUT' : 'GET',
        headers: {
            Accept: 'application/json',
            ...(input ? { 'Content-Type': 'application/json' } : {}),
        },
        ...(input ? { body: JSON.stringify(input) } : {}),
    });
    const data = await r.json();
    if (!r.ok)
        throw new Error(data.message ?? 'No pudimos consultar la numeración del socio.');
    return data;
}
export const getMemberNumber = (base, id, signal) => call(base, id, undefined, signal);
export const assignMemberNumber = (base, id, input) => call(base, id, input);
export async function transferMemberAliquot(base, memberId, assignmentId, input) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/aliquots/${encodeURIComponent(assignmentId)}/transfer`, { method: 'POST', credentials: 'include', headers: { Accept: 'application/json', 'Content-Type': 'application/pdf', 'X-Urbanik-Buyer-Id': encodeURIComponent(input.buyerMemberId), 'X-Urbanik-Effective-On': encodeURIComponent(input.effectiveOn), 'X-Urbanik-Reference': encodeURIComponent(input.reference), 'X-Urbanik-Reason': encodeURIComponent(input.reason), 'X-Urbanik-File-Name': encodeURIComponent(input.file.name) }, body: input.file });
    const body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No se pudo transferir la alícuota.');
    return body;
}
export async function acquireAvailableAliquot(base, memberId, input) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/aliquots`, { method: 'POST', credentials: 'include', headers: { Accept: 'application/json', 'Content-Type': 'application/pdf', 'X-Urbanik-Slot-Number': encodeURIComponent(input.number), 'X-Urbanik-Effective-On': encodeURIComponent(input.effectiveOn), 'X-Urbanik-Reference': encodeURIComponent(input.reference), 'X-Urbanik-Reason': encodeURIComponent(input.reason), 'X-Urbanik-File-Name': encodeURIComponent(input.file.name) }, body: input.file });
    const body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No se pudo agregar la alícuota.');
    return body;
}
